import React from 'react';

interface Signature {
  id: string;
  name: string;
  html: string;
  assignments?: string[];
}

interface SignatureListProps {
  signatures: Signature[];
  onSelectSignature: (signature: Signature) => void;
  onNewSignature: () => void;
  onBack: () => void;
}

const SignatureList: React.FC<SignatureListProps> = ({
  signatures,
  onSelectSignature,
  onNewSignature,
  onBack
}) => {
  return (
    <div className="signature-list-view">
      <div className="list-header">
        <button className="btn-back" onClick={onBack}>
          ← Back to Dashboard
        </button>
        <h2>Signatures</h2>
        <button className="btn-primary" onClick={onNewSignature}>
          + New Signature
        </button>
      </div>

      <div className="signature-grid">
        {signatures.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📝</div>
            <h3>No signatures yet</h3>
            <p>Create your first email signature to get started</p>
            <button className="btn-primary" onClick={onNewSignature}>
              + Create Signature
            </button>
          </div>
        ) : (
          signatures.map(sig => (
            <div
              key={sig.id}
              className="signature-card"
              onClick={() => onSelectSignature(sig)}
            >
              <div className="signature-card-header">
                <h3>{sig.name || 'Untitled Signature'}</h3>
              </div>
              <div className="signature-preview" dangerouslySetInnerHTML={{ __html: sig.html }} />
              <div className="signature-card-footer">
                <span className="assignment-count">
                  {sig.assignments?.length || 0} group{sig.assignments?.length !== 1 ? 's' : ''} assigned
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SignatureList;
